
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4 4V1a1 1 0 011-1h12a1 1 0 011 1v14a1 1 0 01-1 1h-3v3c0 .552-.45 1-1.007 1H1.007A1 1 0 010 19L.003 5c0-.552.45-1 1.006-1H4zM2.002 6L2 18h10V6H2.002zM6 4h8v10h2V2H6v2zM4 9h6v2H4V9zm0 4h6v2H4v-2z","fill":"#FAAD14"}})])
          )
        }
      }
    